<template>
<div>
    <v-sheet>
      <div v-if="myState.pdf" id="my_pdf_viewer">
        <div id="canvas_container">
          <canvas ref="canvas"></canvas>
        </div>
        <v-divider></v-divider>
        <div id="navigation_controls">
          <v-btn icon :disabled="myState.currentPage <= 1" @click="(myState.currentPage--) & displayPdf() ">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <v-btn icon :disabled="myState.pdf.numPages <= myState.currentPage" @click="(myState.currentPage++) & displayPdf() ">
            <v-icon>chevron_right</v-icon>
          </v-btn>
          <span>{{$t('base.page')}}:{{myState.currentPage}}</span>
        </div>
      </div>
      <v-progress-circular indeterminate v-else :value="40"></v-progress-circular>
    </v-sheet>
</div>
</template>

<script>
import pdfjs from 'pdfjs-dist'
export default {
  props: ['file','base64'],
  components: {

  },
  computed: {

  },
  data() {
    return {
      myState: {
        pdf: null,
        currentPage: 1,
        zoom: 1
      },
      loading: true,
      dialog: false,

    }
  },
  methods: {
    displayPdf() {
      this.myState.pdf.getPage(this.myState.currentPage).then((page) => {

        var canvas = this.$refs.canvas // document.getElementById("pdf_renderer");
        var ctx = canvas.getContext('2d');
        var width = Math.max(window.screen.width, window.innerWidth);
        var viewport = page.getViewport(this.myState.zoom);

        while (viewport.width > width){
          if(viewport.width > width ){
            this.myState.zoom = this.myState.zoom * 0.95
            viewport = page.getViewport(this.myState.zoom);
          }
        }

        canvas.width =  viewport.width;
        canvas.height = viewport.height;
        page.render({
          canvasContext: ctx,
          viewport: viewport
        });
      });

    },
    loadPdf(pdfDocument) {
      pdfjs.getDocument(pdfDocument).then((pdf) => {
        this.myState.pdf = pdf;
        this.displayPdf()
      });
    },
    loadFile(file){
      let reader = new FileReader();
      reader.onload = (e) => this.loadPdf(new Uint8Array(e.target.result))
      reader.readAsArrayBuffer(file);
    },
    loadBase64(base64){
      let arr = base64.split(','),
          bstr = atob(arr[1]),
          n = bstr.length, u8arr = new Uint8Array(n)

      while(n--){
        u8arr[n] = bstr.charCodeAt(n);
      }
      this.loadPdf(u8arr)
    }
  },
  created() {
    return this.file ?  this.loadFile(this.file) : this.base64 ?
        this.loadBase64(this.base64) : null
  },
  watch:{
    file: function (file){
      this.loadFile(file)
    },
    base64: function (base64){
      this.loadBase64(base64)
    }
  }
}
</script>

<style scoped>
.left {
  float: right;
}

.btn-class:hover {
  background-color: #e6e6e6;
  font-size: 1.1rem;
  transition-duration: 0.4s;
}
</style>
